import { styled } from 'styled-components';

export const ToolbarContainer = styled.div`
  font-size: large;
  display: flex;
  max-height: fit-content;
  margin-top: 10px;
`;

export const FeaturesContainer = styled.div`
  width: 100%;
  display: flex;
  z-index: 1;
`;

export const Title = styled.h1`
  margin-left: 30px;
`;
